<template>
  <div class="login-container">
    <el-form ref="loginForm" label-width="150px" class="login-form" :model="loginForm">
      <div class="login-error">{{ this.error }}</div>
      <el-form-item prop="loginName" label="账号">
        <el-input v-model="loginForm.loginName"></el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码">
        <el-input v-model="loginForm.password" type="password"></el-input>
      </el-form-item>
      <el-button type="primary" style="width: 100%" :loading="loading" @click="login">
        登录
      </el-button>
      <div class="login-info">
        如果没有册账号请<router-link to="/user/register">
          点击注册
        </router-link>
      </div>
    </el-form>

  </div>
</template>

<script>
import { RoleCode } from "@/utils/role-constant";
import router from "@/router/index";
export default {
  data() {
    return {
      loading: false,
      error: "",
      loginForm: {
        loginName: 'L0271466',
        email: "",
        password: "Welcome2@",
        comparePassword: "",
      },
      loginRules: {
        email: {
          type: "email",
          required: true,
          message: "请输入有效的邮箱地址",
          trigger: "blur",
        },
        password: {
          type: "string",
          required: true,
          message: "密码不能为空",
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    login() {
      this.$refs["loginForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.error = "";
          this.axios
            .post("/user/login", {
              loginName: this.loginForm.loginName,
              password: this.loginForm.password,
            })
            .then(({ code, data }) => {
              this.loading = true;
              if (code === 200) {
                this.getMenus(data);
              } else if (code === 401) {
                this.$message.error("用户名或密码错误");
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    setMetaTitle(_route, title) {
      router.options.routes.forEach(route => {
        if (route.path === '/') {
          route.children.forEach(child => {
            if (child.path === _route) {
              child.meta.title = title
            }
          })
        }
      })
    },
    getMenus(userInfo) {
      const token = userInfo.token;
      delete userInfo.token;
      this.axios
        .get("/sys/menus", {
          headers: {
            Authorization: token,
          },
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            if (userInfo.role === RoleCode.Admin) {
              this.setMetaTitle('/se', 'HCP List')
            } else if (userInfo.role === RoleCode.VMSL) {
              this.setMetaTitle('/se', 'vCE List')
            }
            this.$store.commit("updateState", {
              role: userInfo.role,
              userInfo: userInfo,
              token: token,
              menus: data,
            });
            let redirect = localStorage.getItem("redirect");
            redirect = redirect ? redirect.split("#") : null;
            console.log(`[redirect] ${redirect}`)
            if (redirect && redirect[1] == userInfo.role) {
              this.$router.push(redirect[0]);
            } else if (redirect) {
              this.$router.push(redirect[0]);
            } else {
              if (data[0].subMenus) {
                this.$router.push(data[0].subMenus[0].url);
              } else {
                this.$router.push(data[0].url);
              }
            }
            localStorage.removeItem("status");
          } else {
            this.$message.error(msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background-color: #f2f3f6;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-form {
    position: relative;
    width: 430px;
    background: #fff;
    padding: 20px;

    .login-info {
      text-align: right;
      font-size: 0.9rem;
      margin-top: 10px;
      color: #909399;
    }

    .login-error {
      color: #f56c6c;
    }
  }
}


</style>
